import { render, staticRenderFns } from "./EvolveGoal.vue?vue&type=template&id=3f0e8c8e"
import script from "./EvolveGoal.vue?vue&type=script&lang=js"
export * from "./EvolveGoal.vue?vue&type=script&lang=js"
import style0 from "./EvolveGoal.vue?vue&type=style&index=0&id=3f0e8c8e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports